<template>
  <v-tooltip bottom content-class="help-guias-tooltip" :max-width="tooltipMaxWidth">
    <template v-slot:activator="{ on, attrs }">
      <v-icon 
        small 
        color="#90A4AE" 
        class="ml-2 help-icon"
        v-bind="attrs" 
        v-on="on"
      >
        mdi-help-circle-outline
      </v-icon>
    </template>
    <div class="tooltip-text">
      <p v-if="helpText">{{ helpText }}</p>
      <ul v-if="normalizedHelpItems.length" class="tooltip-text__list">
        <li v-for="(item, index) in normalizedHelpItems" :key="`help-item-${index}`">
          {{ item }}
        </li>
      </ul>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'HelpGuiasDialog',
  props: {
    helpText: {
      type: String,
      default: ''
    },
    helpItems: {
      type: Array,
      default: () => []
    },
    maxWidth: {
      type: [Number, String],
      default: 320
    }
  },
  computed: {
    normalizedHelpItems() {
      if (!Array.isArray(this.helpItems)) return [];
      return this.helpItems
        .map((item) => (item == null ? '' : String(item).trim()))
        .filter(Boolean);
    },
    tooltipMaxWidth() {
      const n = Number(this.maxWidth);
      return Number.isFinite(n) && n > 0 ? n : 320;
    }
  }
}
</script>

<style scoped>
.help-icon {
  opacity: 0.7;
  transition: all 0.3s ease;
  cursor: pointer;
}

.help-icon:hover {
  opacity: 1;
  transform: scale(1.1);
  color: #64B5F6 !important;
}

.tooltip-text p {
  margin: 6px 0;
  line-height: 1.4;
  font-size: 14px;
  text-align: left;
  white-space: normal;
  word-wrap: break-word;
}

.tooltip-text__list {
  margin: 6px 0 0;
  padding-left: 18px;
  text-align: left;
  font-size: 13px;
  line-height: 1.45;
}

.tooltip-text__list li {
  margin: 4px 0;
  white-space: normal;
  word-wrap: break-word;
}
</style>

<style>
.v-tooltip__content.help-guias-tooltip {
  background-color: #37474F !important;
  color: #FFFFFF !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  font-size: 13px !important;
  line-height: 1.4 !important;
  animation: fadeInTooltip 0.2s ease-in-out;
}

@keyframes fadeInTooltip {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
